import '../../assets/scss/Compliance.scss'

const IBC = () => {
    return(
        <>
        <section className="m-wrap irb-ibc">
          <div className='container'>
            <h2 className="text-hbku-primary p-b-3">Institutional Biosafety Committee (IBC)</h2>
            <p>The Hamad Bin Khalifa University Institutional Biosafety Committee (HBKU-IBC) is constituted to develop and implement institutional biosafety policies and codes of practice. The IBC has the responsibility to ensure that all biomedical research activities involving hazardous materials that may have the capacity to produce adverse effects on human beings, animals or the environment are conducted in a safe manner and in line with applicable regulations. </p>
            <p>The IBC reviews research protocols for work involving research involving infectious agents, animal use, recombinant or synthetic nucleic acid and genetically modified materials. Other functions of the committee may include risk assessments, formulation of new safety policies (in coordination with Institutional Effectiveness Office) and arbitration in disputes over biosafety matters. The IBC carries out the annual inspection of institutional facilities and maintains a register of approved projects that are periodically reviewed to ensure compliance with the containment facilities (e.g. laboratories, animal houses, etc.) as well as the personnel qualification and training records.</p>
            <p>The HBKU-IBC’s responsibility is limited to the HBKU colleges and research institutes, as well as any other organization that relies on HBKU-IBC via a reliance agreement. The IBC aims to review and approve research protocols conducted at or sponsored by these entities for compliance with the Governmental and International Biosafety Guidelines as approved by the Ministry of Public Health <a target='_blank' href='https://research.moph.gov.qa/en/Pages/BiosafetyResearch.aspx?csrt=7054370316874518422'>(MoPH)</a>.</p>

            {/* <p> <strong>Important Notice: Summer Review Delays (June-August) <br></br>The HBKU-IBC members will be traveling intermittently during the summer. As such, there will be delays in reviewing new submissions, with the review timeframe extended to approximately 5 weeks. Thank you for your understanding.</strong></p> */}

            <div className="l-article l-accordion l-accordion4">
                <div className="mez slider">
                    <h3 className="l-accordion__title">
                        <span>How to apply</span>
                    </h3>
                    <div className="l-accordion__content">
                    <ul className="mb-5">
                        <li>For IBC submissions, click this <a href='https://signin.app.cayuse.com/login?tenant_id=aa06a39b-8894-40dc-88c4-07ee4e9f0e31&redirect_uri=https%3A%2F%2Fevmcr4.app.cayuse.com%2Fauthentication&response_type=CODE&state&nonce&auth_error=false' target='_blank'>link</a> and use your login credentials.</li>
                        <li>For login credentials please contact <a href='mailto:hbkuibc@hbku.edu.qa'>hbkuibc@hbku.edu.qa </a></li>
                    </ul>
                    </div>
                    
                    <h3 className="l-accordion__title">
                        <span>Documents</span>
                    </h3>
                    <div className="l-accordion__content">
                    <ul className="mb-5">
                        <li><a href="https://www.hbku.edu.qa/sites/default/files/IBC_Application_Checklist.pdf" target="_blank"> IBC Application Checklist</a></li>
                        <li><a href="https://www.hbku.edu.qa/sites/default/files/IBC_Guidelines_for_Core_Labs.pdf" target="_blank"> IBC Guidelines for Core Labs</a></li>
                        <li><a href="https://www.hbku.edu.qa/sites/default/files/IBC_Exemption_Form.docx" target="_blank"> IBC Exemption Checklist</a></li>
                        {/* <li><a href="https://www.hbku.edu.qa/sites/default/files/ibc_group_protocols.pdf" target="_blank"> IBC Group Protocols</a></li> */}
                        {/* <li><a href="https://www.hbku.edu.qa/sites/default/files/ibc_closure_form_template.pdf" target="_blank"> IBC Closure Form</a></li> */}
                        <li><a href="https://www.hbku.edu.qa/sites/default/files/IBC_Closure_Form.docx" target="_blank"> IBC Closure Form</a></li>
                        
                    </ul>
                    </div>
                    <h3 className="l-accordion__title">
                        <span>Research Non-Compliance Overview</span>
                    </h3>
                    <div className="l-accordion__content">
                        <h3 className='mb-3'>Research Non-Compliance Overview</h3>
                        <h4>Definition of Non-Compliance</h4>
                        <p>Non-compliance refers to any deviation from, or failure to adhere to, applicable local biosafety laws, Ministry of Public Health (MoPH) 
                            regulations, and HBKU-IBC policies designed to protect the health and safety of researchers (directly or indirectly involved), the public, 
                            and the environment. All research involving engineered 
                            genetic materials or other biological hazards must be conducted in strict accordance with MoPH and HBKU-IBC requirements.
                        </p>
                        <h4 className='mb-3'>Examples of Non-Compliance with IBC Requirements Include, but Are Not Limited To:</h4>
                        <ul class="number-ul">
                            <li>
                                <strong>Failure to obtain initial IBC approval or to renew existing approval</strong> prior to initiating or continuing any research 
                                involving recombinant or synthetic nucleic acid molecules, biohazardous agents (e.g., microbiological organisms, clinical 
                                samples including human blood and body fluids, primary or immortalized human cell lines, or other 
                                potentially infectious materials).
                            </li>
                            <li>
                                <strong>Conducting research under expired IBC approval,</strong> including sample collection, laboratory work, or use of regulated materials without timely renewal.
                            </li>
                            <li>
                                <strong>Deviating from the approved protocol</strong> without prior IBC review and approval through an official amendment submission process.
                            </li>
                            <li>
                                <strong>Implementing changes to personnel, procedures, agents, or facilities </strong> 
                                (including biosafety level, equipment, or containment practices) without obtaining prior IBC approval.
                            </li>
                            <li>
                                <strong>Failure to report adverse events, laboratory incidents, or potential biosafety breaches </strong> to the IBC and other appropriate entities in a timely manner.
                            </li>
                            <li>
                                <strong>Failure to disclose conflicts of interest </strong> that may compromise the objectivity or integrity of the research.
                            </li>
                            <li>
                                <strong>Inadequate training or documentation of biosafety training </strong> for all personnel listed on the approved protocol, including new team members who begin work without appropriate biosafety clearance.
                            </li>
                            <li>
                                <strong>Failure to maintain accurate and complete records </strong> related to biosafety training, protocol approvals, incident reports, and other required documentation.
                            </li>
                            <li>
                                <strong>Use of unapproved or unauthorized laboratory</strong> for work involving biohazardous or recombinant materials
                            </li>
                            <li>
                                <strong>Failure to follow biosafety level (BSL) or standard operating procedure (SOP) requirements,</strong> including the use of appropriate personal protective equipment (PPE), engineering controls (e.g., biosafety cabinets), and containment protocols.
                            </li>
                            <li>
                                <strong>Misuse or unauthorized sharing of regulated biological materials,</strong> including transferring agents to other institutions or researchers without appropriate permissions or agreements.
                            </li>
                            <li>
                                <strong>Failure to suspend research activities </strong> after being notified of suspension or termination of IBC approval.
                            </li>
                            <li>
                                <strong>Failure to maintain accurate and up-to-date records, </strong> including biosafety manuals, inventory logs, training records, and inspection reports.
                            </li>
                            <li>
                                <strong>Failure to cooperate with IBC inspections, audits, or investigations, </strong> or to address required corrective actions in a timely manner.
                            </li>
                        </ul>

                        <h4 className='mb-3'>Types of Non-Compliance</h4>
                        <ul class="number-ul">
                            <li><strong>Low Risk Non-Compliance Event:</strong> This includes a minor deviation from the approved biosafety procedures/protocol that poses minimal threat to personnel, the public, or the environment. The event may include procedural lapses without direct exposure to infectious agents.</li>
                            <li><strong>High Risk Non-Compliance Event:</strong> Actions that significantly increase risk to researchers involved directly or indirectly affect their safety and well-being as well as the community and the environment, or that compromise the scientific integrity of the research.</li>
                            <li><strong>Persistent Non-compliance Event:</strong> Repeated or ongoing non-compliance violations across one or more studies under an individual Principal Investigator (PI), indicating a persistent pattern that can impact participants or research validity.</li>
                        </ul>

                        <h4>Reporting Non-Compliance</h4>
                        <p>
                            All instances of non-compliance must be reported promptly to the HBKU-IBC. This includes self-reporting or reports from 
                            others (e.g., staff or oversight authorities). Reports should be submitted via email to the IBC Office and must include 
                            the Research Compliance Manager, Biosafety Officer, and IBC Chair in the correspondence.
                        </p>

                        <h4>Documentation of Non-Compliance</h4>
                        <p>When self-reporting non-compliance, the PI or research team must submit to the IBC a written summary detailing the following:</p>
                        <ul class="number-ul">
                            <li>A clear description of the non-compliance incident.</li>
                            <li>Its impact on research and potential risks.</li>
                            <li>The measures being taken to correct the issue and prevent recurrence.</li>
                        </ul>
                        <p>This report should be submitted to the HBKU IBC official email copying within the correspondence the Research Compliance Manager, Biosafety Officer and IBC Chair.</p>
                        
                        <h4>IBC Review and Actions</h4>
                        <p>
                            Upon receiving a non-compliance report, it will initially be discussed with selected members of the committee and necessary 
                            actions will be taken accordingly. This will include assessment of nature and severity, classifying it as low risk, high risk, 
                            or persistent non-compliance based on definitions in the policy. The IBC will also consider potential risks to researchers 
                            involved directly or indirectly, the community and the environment and mitigating factors.
                        </p>
                        <p>
                            If it's classified as low-risk non-compliance, it can be reviewed by the Chair, BSO and/or the appointed 
                            reviewer and the PI will be notified accordingly. For high risk or persistent non-compliance, a full committee 
                            review is required. The IBC may conduct further investigations and audits and may request the PI’s presence to 
                            clarify the situation and determine if corrective actions are necessary.
                        </p>
                        <p>The IBC reviews report of non-compliance and may impose corrective actions, such as:</p>
                        <ul>
                            <li>Study-specific revisions or corrective measures</li>
                            <li>Education for the research team</li>
                            <li>Modifications to protocols </li>
                            <li>Suspension or termination of IBC approval</li>
                            <li>Increased oversight or monitoring of future research</li>
                        </ul>
                        <h4 className='mb-3'>Suspension or Termination of IBC Approval</h4>
                        <p>
                           The IBC can suspend or terminate a study if non-compliance occurs, especially if it leads to increased risks. 
                           The IBC's decision will be communicated to the Principal Investigator and institutional officials. 
                        </p>
                        <h4 className='mb-3'>Contact Points: </h4>
                        <p>HBKU IBC: <a className='text-blue' href="mailto:hbkuibc@hbku.edu.qa">hbkuibc@hbku.edu.qa</a></p>
                        <p>Research Compliance Manager: <a className='text-blue' href="mailto:salnuaimi@hbku.edu.qa">salnuaimi@hbku.edu.qa</a></p>
                        <p>Biosafety Officer: <a className='text-blue' href="mailto:abkhilan@hbku.edu.qa">abkhilan@hbku.edu.qa</a></p>
                        <p>IBC Chair: <a className='text-blue' href="mailto:pkolatkar@hbku.edu.qa">pkolatkar@hbku.edu.qa</a></p>


                    </div>
                    <h3 className="l-accordion__title">
                        <span>Review Timeframe</span>
                    </h3>
                    <div className="l-accordion__content">

                    <h5>Exempt Category </h5>
                    <p>
                        
                        Studies that qualify for exempt category review require completion of the IBC Exemption Checklist by the PI. 
                        Once the request is received by the IBC Office and all the information is reviewed and verified for exemption, 
                        the approval will be processed within <strong>5 working days.</strong> For additional details or requirements, please contact the 
                        HBKU IBC Office at <a className='text-blue' href="mailto: hbkuibc@hbku.edu.qa." aria-label="Mail to hbkuibc@hbku.edu.qa.">hbkuibc@hbku.edu.qa.</a>

                    </p>
                    
                    <h5>Designated Member Review (DMR)</h5>
                    <p>
                        Applications reviewed under the Designated Member Review category—primarily 
                        Biosafety Level (BSL) I—follow the estimated timelines below for approval:
                    </p>
                    <ul>
                        <li><strong>Initial Applications: </strong> Approximately <strong>5–6 weeks</strong></li>
                        <li><strong>Renewal Applications </strong> Approximately <strong>5–6 weeks</strong></li>
                        <li><strong>Amendment Applications: </strong> Approximately <strong>3-4 weeks</strong></li>
                    </ul>

                    <p>Applications requiring a lab audit may take an <strong> additional two weeks</strong>, subject to the   BSO’s availability and the number of pending lab audits </p>
                    <p>Actual review duration may vary depending on the PI’s responsiveness and timely resolution of reviewer comments and providing critical documents.</p>

                    <h5>Full Committee Review (FCR)</h5>
                    <p>
                        Applications requiring Full Committee Review—typically BSL II—undergo a <strong>two-phase
                        review and approval process.</strong> Applications requiring a lab audit may take an  
                        additional two weeks, subject to the BSO’s availability and the number of pending 
                        lab audits. 
                    </p>

                    <h5>Phase 1: Committee Member Review</h5>
                    <p>This phase follows the same estimated timeline as the DMR category and may vary 
                        based on the PI’s responsiveness and timely resolution of reviewer comments and   
                        providing critical documents:
                    </p>
                    <ul>
                        <li><strong>Initial Applications: </strong> Approximately <strong>5–6 weeks</strong></li>
                        <li><strong>Renewal Applications </strong> Approximately <strong>5–6 weeks</strong></li>
                        <li><strong>Amendment Applications: </strong> Approximately <strong>3-4 weeks</strong></li>
                    </ul>

                    <h5>Phase 2: Full Committee Approval</h5>
                    <p>
                        Following completion of Phase 1, applications proceed to the IBC Board convened meeting, 
                        held <strong>on the second Monday of each month</strong>, for final review and approval.
                    </p>

                    <p>Actual review duration may vary depending on the PI’s responsiveness and timely resolution of reviewer comments and providing critical documents.</p>

                    <p>
                        Please note that <strong>delays may occur</strong> during the summer period (particularly July and August) due to reviewer unavailability, during national holidays 
                        that coincide with scheduled IBC meetings, or in cases where a meeting cannot be held due to lack of quorum. Delays may also occur during periods 
                        of high application volume. 
                    </p>
                    </div>
                    
                </div>
            </div>
            <h3 className="text-hbku-primary p-b-2 p-t-2">HBKU-IBC Members</h3>
            <p>HBKU-IBC members are comprised of representatives of biosafety officers, laboratory technical staff and scientists with varying backgrounds of research expertise: </p>
            <div className="filter-container">
                <table className="views-table full-width" style={{backgroundColor: '#ffffff'}}>
                    <thead>
                        <tr>
                            <th className="f-project-title">Name </th>
                            <th className="f-project-lead">Entity </th>
                            <th className="f-project-entity">Role </th>
                        </tr>
                    </thead>
                    <tbody>
                    <tr className="even">
                        <td>Dr. Prasanna Kolatkar</td>
                        <td>HBKU QBRI</td>
                        <td>Chair</td>
                    </tr>
                    <tr className="odd">
                        <td>Dr. Salah Mogith</td>
                        <td>Sidra Medicine</td>
                        <td>Deputy Chair</td>
                    </tr>
                    <tr className="even">
                        <td>Dr. Abdulghani Khilan</td>
                        <td>HBKU</td>
                        <td>Biosafety Officer</td>
                    </tr>
                    {/* <tr className="odd">
                        <td>Dr. Matteo Avella</td>
                        <td>Sidra Medicine</td>
                        <td>Member</td>
                    </tr> */}
                    {/* <tr className="even">
                        <td>Dr. Ajaz Bhat</td>
                        <td>Sidra Medicine</td>
                        <td>Member</td>
                    </tr>
                    <tr className="odd">
                        <td>Mr. Carl Bjorkhammer</td>
                        <td>Sidra Medicine</td>
                        <td>Member</td>
                    </tr> */}
                    <tr className="even">
                        <td>Dr. Nady El Hajj</td>
                        <td>HBKU CHLS</td>
                        <td>Member</td>
                    </tr>
                    <tr className="odd">
                        <td>Dr. Yongsoo Park</td>
                        <td>HBKU QBRI</td>
                        <td>Member</td>
                    </tr>
                    <tr className="even">
                        <td>Dr. Dindial Ramotar</td>
                        <td>HBKU CHLS</td>
                        <td>Member</td>
                    </tr>
                     <tr className="odd">
                        <td>Dr. Julia Reichelt</td>
                        <td>HMC</td>
                        <td>Member</td>
                    </tr>
                    <tr className="even">
                        <td>Dr. Nandakumar Pillai</td>
                        <td>QF</td>
                        <td>Member</td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <br /> <br />
            <h3 className="text-hbku-primary p-b-2 p-t-2">IBC Meetings 2025</h3>
            <p>IBC meetings typically take place on the second Monday of every month</p>
            {/* <div className="filter-container">
                <table className="views-table full-width" style={{backgroundColor: '#ffffff'}}>
                    <thead>
                        <tr>
                            <th className="f-project-title">Month </th>
                            <th className="f-project-lead">Submission Deadline </th>
                            <th className="f-project-entity">Meeting Dates </th>
                        </tr>
                    </thead>
                    <tbody>
                    <tr className="odd">
                        <td>March</td>
                        <td>27 February</td>
                        <td>13 March</td>
                    </tr>
                    <tr className="even">
                        <td>April</td>
                        <td className="text-center">Ramadan and Eid*</td>
                        <td> &nbsp; </td>
                    </tr>
                    <tr className="odd">
                        <td>May</td>
                        <td>1 May</td>
                        <td>15 May</td>
                    </tr>
                    <tr className="even">
                        <td>June</td>
                        <td>29 May</td>
                        <td>12 June</td>
                    </tr>
                    <tr className="odd">
                        <td>July</td>
                        <td>26 June</td>
                        <td>10 July</td>
                    </tr>
                    <tr className="even">
                        <td>August</td>
                        <td>31 July</td>
                        <td>14 August</td>
                    </tr>
                    <tr className="odd">
                        <td>September</td>
                        <td>28 August</td>
                        <td>11 September</td>
                    </tr>
                    <tr className="even">
                        <td>October</td>
                        <td>2 October</td>
                        <td>16 October</td>
                    </tr>
                    <tr className="odd">
                        <td>November</td>
                        <td>30 October</td>
                        <td>13 November</td>
                    </tr>
                    <tr className="even">
                        <td>December</td>
                        <td>27 November</td>
                        <td>11 December</td>
                    </tr>
                    </tbody>
                </table>
                <br></br>
            </div> */}
            <p><strong>Kindy be advised: </strong> IBC submissions are reviewed as received. Complete applications must be submitted by the “Submission Deadline” for consideration at the corresponding meeting. Meeting dates are tentative upon achieving quorum for each meeting scheduled.</p>
            <br /> <br />
           </div>
        </section>
        </>
        )
    }
export default IBC;